<template>
  <form @submit.prevent="onSubmitForm">
    <div class="mb-3">
      <elsa-v-select
        :options="paymentTypes"
        v-model="data.type"
        label="name"
        :reduce="item => item.id"
        :clearable="false"
        htmlLabel="Тип платежа"
        styleType="largeLabel"
        :danger="errors.type"
        danger-text="Выберите тип платежа"
        @input="errors.type=false"
      />
    </div>
    <div class="mb-3">
      <elsa-v-datepicker
        label="Дата проведения по банку"
        v-model="data.payment_create_date"
        :clearable="false"
      />
    </div>
    <div class="mb-3">
      <vs-input
        label="Зачислено"
        class="w-full"
        :value="amount"
        :disabled="true"
      />
    </div>
    <div class="mb-3">
      <vs-input
        label="Комиссия"
        class="w-full"
        v-model="data.amount_agency"
        v-currency
      />
    </div>
    <div class="mb-3">
      <vs-input
        label="Сумма"
        class="w-full"
        v-model="data.all_amount"
        v-currency
      />
    </div>

    <div class="mt-4 text-center">
      <vs-button button="submit" type="border" color="success">
        Сохранить
      </vs-button>
    </div>

    <div v-if="loading" class="block-loading-container">
      <div class="block-loading"></div>
    </div>
  </form>
</template>

<script>
import parseDate    from "@/client/helpers/parseDate";
import formatDate   from "@/client/helpers/formatDate";
import modalContext from "@/mixins/modalContext";
import currency     from "currency.js";

export default {
  name:   "EditPaymentPopup",
  mixins: [modalContext],
  props:  ['payment', 'onSubmit'],
  data() {
    const { type, payment_create_date, amount, amount_agency, all_amount } = this.payment;
    return {
      loading:      false,
      data:         {
        type,
        payment_create_date: parseDate(payment_create_date),
        amount,
        amount_agency,
        all_amount,
      },
      errors:       {},
      paymentTypes: [],
    };
  },
  computed: {
    amount() {
      return currency(this.data.all_amount).subtract(this.data.amount_agency).toString();
    },
  },
  methods:  {
    loadPaymentTypes() {
      return this.$http.get('invoices_type').then(( { data } ) => {
        this.paymentTypes = data;
      });
    },

    onSubmitForm() {
      const { type, payment_create_date, amount_agency, all_amount } = this.data;
      this.loading = true;
      return this.onSubmit({
        type,
        payment_create_date: formatDate(payment_create_date, 'yyyy-MM-dd'),
        amount_agency,
        all_amount,
      }).then(
        () => this.modalResolve(),
        () => this.loading = false,
      );
    },
  },
  mounted() {
    this.loadPaymentTypes();
  },
};
</script>

<style scoped>

</style>
